import { __assign, __rest } from "tslib";
import React from "react";
import { StatusTip } from "../../tips";
import { useTranslation } from "../../i18n";
/**
 * 给定表格数据的状态，自动提供合适的 topTip 来显示该状态
 */
export function autotip(options) {
    var isFound = options.isFound, isLoading = options.isLoading, isError = options.isError, foundText = options.foundText, emptyText = options.emptyText, foundKeyword = options.foundKeyword, foundCount = options.foundCount, _a = options.foundKeywordMaxLength, foundKeywordMaxLength = _a === void 0 ? 20 : _a, tipProps = __rest(options, ["isFound", "isLoading", "isError", "foundText", "emptyText", "foundKeyword", "foundCount", "foundKeywordMaxLength"]);
    return {
        getInfo: function () { return ({ name: "autotip" }); },
        onInjectProps: function (props) {
            // 根据数据情况、加载情况、关键字情况使用不同的 Tips 渲染
            var topTip = null;
            var tipStatus = null;
            var records = props.records || [];
            var recordCount = typeof foundCount === "undefined" ? records.length : foundCount;
            if (isLoading) {
                tipStatus = "loading";
            }
            else if (isError) {
                tipStatus = "error";
            }
            else if (isFound) {
                tipStatus = "found";
            }
            else if (recordCount === 0) {
                tipStatus = "empty";
            }
            if (tipStatus) {
                topTip = (React.createElement(DefaultFoundTextProvider, { foundText: foundText, foundKeyword: foundKeyword, recordCount: recordCount, foundKeywordMaxLength: foundKeywordMaxLength }, function (tableFoundText) { return (React.createElement(StatusTip, __assign({ status: tipStatus, foundText: tableFoundText, emptyText: emptyText }, tipProps))); }));
            }
            return __assign(__assign({}, props), { topTip: topTip });
        },
    };
}
function DefaultFoundTextProvider(_a) {
    var foundText = _a.foundText, foundKeyword = _a.foundKeyword, recordCount = _a.recordCount, foundKeywordMaxLength = _a.foundKeywordMaxLength, children = _a.children;
    var t = useTranslation();
    if (foundText) {
        return children(foundText);
    }
    if (foundKeyword) {
        if (recordCount === 0) {
            return children(t.foundNothingWithKeyword(foundKeyword));
        }
        // eslint-disable-next-line no-param-reassign
        foundKeyword =
            foundKeyword.slice(0, foundKeywordMaxLength) +
                (foundKeyword.length > foundKeywordMaxLength ? "..." : "");
        return children(t.foundManyTextWithKeyword(foundKeyword, recordCount));
    }
    return children(t.foundManyText(recordCount));
}
/**
 * 从 Tea v1 的 SmartTips.render() 参数构造成新的 autotip 插件
 */
autotip.fromLegacyState = function (_a) {
    var enableLoading = _a.enableLoading, fetcher = _a.fetcher, query = _a.query, onClearSearch = _a.onClearSearch, onRetry = _a.onRetry, emptyTips = _a.emptyTips;
    var search = query && query.search;
    return autotip({
        isLoading: (enableLoading !== false || search) && fetcher.loading,
        isError: fetcher.fetchState === "Failed",
        foundKeyword: search,
        onClear: onClearSearch,
        onRetry: onRetry,
        emptyText: emptyTips,
    });
};
//# sourceMappingURL=autotip.js.map